import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, FormArray } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { DocumentTypeService } from '../services/document-type.service';
import {DocumentType} from '../models/documentType.model';
import { DocumentTypeAttribute } from '../models/documentTypeAttribute.model';
import { UserService } from '../services/user.service';
import { AttributeReference } from '../models/documentTypeReference.model';
import { BaseEntity } from '../base/BaseEntity';
import { queryOperators } from '../documents/values/operators';
import {CdkDragDrop, moveItemInArray, transferArrayItem, CdkDragHandle} from '@angular/cdk/drag-drop';
import { MatDialog, MatDialogConfig, MatTable } from '@angular/material';
import { DocumentTypeReferenceOptionsComponent } from '../document-type-options/document-type-reference-options/document-type-reference-options.component';

@Component({
  selector: 'app-document-type-edit',
  templateUrl: './document-type-edit.component.html',
  styleUrls: ['./document-type-edit.component.css']
})
export class DocumentTypeEditComponent implements OnInit {
  typeForm: FormGroup;
  private type: DocumentType;
  public references: AttributeReference[];
  isEdit = false;
  public defaultFilters = queryOperators;

  constructor(
    private notificationsService: ToastrService,
    private router: Router,
    private typeService: DocumentTypeService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    public userService: UserService,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.typeForm = new FormGroup({
      id: new FormControl(),
      name: new FormControl(),
      systemCode: new FormControl(),
      attributeLeft: new FormControl(),
      attributeRight: new FormControl(),
      isCommon: new FormControl(false),
      hasIndex: new FormControl(false),
      attributes: this.fb.array([])
    });
    const id = this.activatedRoute.snapshot.params['id'];
    if (id) {
      this.isEdit = true;
      this.GetActiveRecord(id);
    } else {
      this.InitializeNew();
    }
    this.typeService.getReferences().subscribe((resp) => {
      this.references = resp.payload;
    });
  }
  dropTable(event: CdkDragDrop<[]>) {
    const prevIndex = this.typeForm['controls'].attributes['controls'].findIndex((d) => d === event.item.data);
    const attributeArray = <FormArray>this.typeForm.get('attributes');
    const currentGroup = attributeArray.at(prevIndex);
    attributeArray.removeAt(prevIndex);
    attributeArray.insert(event.currentIndex, currentGroup);
    //moveItemInArray(attributeArray.controls, prevIndex, event.currentIndex);
  }
  initItems(): FormGroup {
    const attribute = {
      id: new FormControl(null),
      typeId: new FormControl([null, Validators.required]),
      name: [null, Validators.required],
      referenceInfo: new FormControl(),
      code: new FormControl(null),
      isMandatory: new FormControl(null),
      isReadOnly: new FormControl(null),
      systemCode: new FormControl(null),
      defaultFilter: new FormControl(null)
    };
    attribute.code.valueChanges.subscribe(value => {
      if (value === 'reference') {
        attribute.referenceInfo.enable();
      } else {
        attribute.referenceInfo.disable();
      }
    });
    return this.fb.group(attribute);
  }
  addRow() {
    // This function instantiates a FormGroup for each day
    // and pushes it to our FormArray

    // We get our FormArray
    const control = <FormArray>this.typeForm.controls['attributes'];

    // instantiate a new day FormGroup;
    const row: FormGroup = this.initItems();
    row.get('id').setValue(DocumentType.GetEmptyGuid());

    // Add it to our formArray
    control.push(row);
  }
  removeRow(i) {
    if (i >= 0) {
      const control = <FormArray>this.typeForm.controls['attributes'];
      control.removeAt(i);
    }

  }
  private InitializeNew() {
    this.type = new DocumentType();
  }
  private GetActiveRecord(id: string) {
    this.typeService.Get(id).subscribe((result) => {
      this.type = result.payload;
      if (!this.type.attributes) {
        this.type.attributes = [];
      }
      const control = <FormArray>this.typeForm.controls['attributes'];
      if (result.payload.attributes) {
        result.payload.attributes.forEach( (attribute) => {
          const row = this.initItems();
          row.patchValue(attribute);
          control.push(row);
        });
      } else {
      }
      this.typeForm.patchValue(result.payload);
    });
  }

  public OnCancel() {
   this.router.navigate(['/documentType']);
  }
  public OnTypeSelected(item: FormGroup, e: any) {
    if (e) {
      item.patchValue({
        typeId: e.id,
        code: e.code,
      });
      if (e.code !== 'reference') {
        const referenceInfo = item.get('referenceInfo');
        if (referenceInfo) {
          referenceInfo.patchValue(this.typeService.EmptyReference);
        }
      }
    } else {
      item.patchValue({
        typeId: null,
        code: null,
      });
    }
  }
  public OnSubmit() {
    let type: DocumentType;
    type = this.typeForm.value;
    type.code = type.name;
    if (this.isEdit) {
      this.typeService.Update(type).subscribe(() => {
        this.notificationsService.success('Document edited:' + type.name, 'Document Type');
        this.router.navigate(['/documentType']);
      });
    } else {
      this.typeService.Create(type).subscribe(() => {
        this.notificationsService.success('Document created:' + type.name, 'Document Type');
        this.router.navigate(['/documentType']);
      });
    }

  }
  compareReferences(o1: any, o2: any): boolean {
    return o1 && o2 && o1.name === o2.name && o1._id === o2._id;
  }

  getReferenceOptions(index:number):any{
    const ret = {
      allowManual: false
    };
    const array = <FormArray>this.typeForm.get('attributes');
    const attribute:FormGroup = <FormGroup>array.at(index);
    if(attribute){
      const referenceInfo:FormControl = <FormControl>attribute.controls['referenceInfo'];
      const v = referenceInfo.value;
      ret.allowManual = v.allowManual;
    }

    return ret;
  }

  onOptions(typeCode:string, index:number){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    let dialogRef = null;
    switch (typeCode){
      case 'reference':
        dialogConfig.data = this.getReferenceOptions(index);
        dialogRef = this.dialog.open(DocumentTypeReferenceOptionsComponent, dialogConfig);
        break;
      default:
        break;
    }
    if(dialogRef){
      dialogRef.afterClosed().subscribe((result: any) => {
        const array = <FormArray>this.typeForm.get('attributes');
        const attribute:FormGroup = <FormGroup>array.at(index);
        if(attribute && result){
          switch(typeCode){
            case 'reference':
              const referenceInfo:FormControl = <FormControl>attribute.controls['referenceInfo'];
              const v = referenceInfo.value;
              v.allowManual = result.allowManual;
              referenceInfo.setValue(v);
              break;
            default:
              break;
          }
          //allowManual

        }
      });
    }    
  }
}
